@if (isBrowser) {
  <ng-container *transloco="let t">
    <p-dialog
      [modal]="true"
      [visible]="visible()"
      (visibleChange)="visible.set($event)"
      [style]="{ width: '90vw', maxWidth: '420px' }"
      maskStyleClass="backdrop-blur-sm"
      [closable]="true"
      [header]="t('guestBanner.resetModal.header')"
    >
      <p class="text-surface-600 dark:text-surface-300 text-sm">
        {{ t('guestBanner.resetModal.message') }}
      </p>

      <ng-template #footer>
        <div class="flex justify-end gap-2">
          <p-button
            [label]="t('guestBanner.resetModal.cancel')"
            severity="secondary"
            [outlined]="true"
            (onClick)="cancel()"
          />
          <p-button
            [label]="t('guestBanner.resetModal.confirm')"
            severity="danger"
            (onClick)="confirm()"
          />
        </div>
      </ng-template>
    </p-dialog>
  </ng-container>
}
